export default __webpack_public_path__ + "static/media/vbinaar.c1a59c75.jpg";